import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SmartToySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SmartToySVG;
